import React from 'react';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import ResponsibidAppIcon from 'housecall-ui/dist/IconsAndImages/AppIcons/ResponsibidAppIcon';

import ResponsibidButton from '../OtherComponents/ResponsibidButton';

const ResponsibidStrategy = {
  previewInfo: {
    name: 'ResponsiBid',
    iconSvg: <ResponsibidAppIcon size="xlarge" />,
    newTab: false,
  },
  headerInfo: {
    name: 'ResponsiBid',
    category: 'The ultimate selling add-on for cleaning companies',
    details: (
      <div>
        ResponsiBid is a sales acceleration tool for window cleaning, pressure washing, carpet cleaning, maid service,
        and other home service companies that specialize in cleaning. ResponsiBid has tools for using specs to calculate
        package offerings for your customers. In addition, the automated follow-up allows no sales opportunity to slip
        through the cracks. And when the customer is ready to schedule ResponsiBid has an intelligent scheduling feature
        called “CrewCal” that reads your HCP calendar and determines the best drive times as well as capacity
        availability and crew speeds to suggest the most efficient times to schedule a specific job given your
        schedule’s availability.
        <br /> <br />
        The connection with Housecall Pro allows for quotes in ResponsiBid to transfer over to HCP once the customer
        schedules from the quotes. You can also integrate your HCP schedule so that when ResponsiBid is helping you
        close the job, the dates and times offered are the most efficient possible!
        <br /> <br />
        To learn more, feel free to visit us at <a href="https://get.responsi.bid/hcp">https://get.responsi.bid/hcp</a>
      </div>
    ),
    iconSvg: <ResponsibidAppIcon size="xlarge" />,
  },
  sellingPoints: {
    headline: 'Features include:',
    description: '',
    unorderedPoints: [
      'Online accurate quoting',
      'Phone & field accurate quoting',
      'Infinite follow-up sequences with email and SMS (other options available with other connections)',
      'Intelligent customer self-scheduling',
      'Intelligent admin scheduling tools',
      'More!',
    ],
  },
  planAvailability: {
    title: 'Housecall Pro Plan',
    description: (
      <Grid container spacing={8}>
        <Grid item xs={4}>
          <Typography align="left" variant="body1">
            Basic plan
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            Essentials plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            MAX plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
      </Grid>
    ),
  },
  price: {
    title: 'Partner Pricing',
    hideToggle: true,
    appActionButton: <ResponsibidButton />,
    description: (
      <div>
        <Grid container spacing={8}>
          <Grid item>
            <Typography align="left">
              <a href="https://responsibid.com/pricing/" target="_blank" rel="noreferrer">
                https://responsibid.com/pricing/
              </a>
            </Typography>
          </Grid>
          <Grid item>
            <Typography align="center" color="textSecondary">
              To use the integration, you must have an account with ResponseBid. Starting at $225/month
            </Typography>
          </Grid>
        </Grid>
      </div>
    ),
  },
  supportContacts: [
    { type: 'Phone', contact: '(707) 968 7764' },
    {
      type: 'Email',
      contact: (
        <a href="mailto:support@symphosize.com" target="_blank" rel="noreferrer">
          support@symphosize.com
        </a>
      ),
    },
    {
      type: 'Help center',
      contact: (
        <a href="https://docs.symphosize.com/responsibid" target="_blank" rel="noreferrer">
          https://docs.symphosize.com/responsibid
        </a>
      ),
    },
  ],
};

export default ResponsibidStrategy;
